// extracted by mini-css-extract-plugin
module.exports = {"languageSwitcher":"language-switcher_languageSwitcher__25PKm","current":"language-switcher_current__1Q6Qg"};